// extracted by mini-css-extract-plugin
export default {"ListeningVideo":"Listening_ListeningVideo__VcyoB","ListeningAudio":"Listening_ListeningAudio__-J84R"};